var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.auth && !_vm.success
      ? _c(
          "button",
          { staticClass: "update-button", on: { click: _vm.clickHandler } },
          [
            _c("i", {
              staticClass: "uk-icon-refresh",
              class: { "uk-icon-spin": _vm.isLoading },
            }),
            _vm._v(" "),
            _vm._t("default", function () {
              return [_vm._v("Обновить информацию")]
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.auth && _vm.success
      ? _c(
          "span",
          { staticClass: "success" },
          [
            _c("i", { staticClass: "uk-icon-check" }),
            _vm._v(" "),
            _vm._t("success", function () {
              return [_vm._v("Информация актуальна")]
            }),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.auth
      ? _c("span", { staticClass: "demo" }, [
          _c("i", { staticClass: "uk-icon-remove" }),
          _vm._v(
            "\n         В демо-режиме обновление информации недоступно.\n     "
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }